import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {Link} from 'react-router';
import Tooltip from 'components/Tooltip';

const ImageSummaryCard = createReactClass({
  propTypes: {
    kitToken: PropTypes.string.isRequired,
    workingSetImage: ImmutablePropTypes.record.isRequired,
  },

  getInitialState() {
    return {
      imageFocused: false,
    };
  },

  handleImageFocused() {
    this.setState({imageFocused: !this.state.imageFocused});
  },

  render() {
    const {kitToken, workingSetImage} = this.props;
    const {imageFocused} = this.state;
    const editTooltip = (imageFocused) ? <Tooltip content={`Edit ${workingSetImage.name}`} icon="ficon-pencil" /> : null;

    return (
      <Link to={`/kits/${kitToken}/images/${workingSetImage.id}`} className="m-xs-b-lg asset asset-image link-dashed-none">
        <div className="asset-inner" onMouseOver={this.handleImageFocused} onMouseOut={this.handleImageFocused}>
          {editTooltip}
          <div className="asset-preview bg-img-checkered">
            <img className="asset-source" src={workingSetImage.optimizedUrl} alt={workingSetImage.name} />
          </div>
        </div>
      </Link>
    );
  },
});

export default ImageSummaryCard;



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/ImageSummaryCard.js